/* src/app/features/contratacao/limite/limite-historico/limite-historico-pesquisa/limite-historico-pesquisa.component.scss */
.blur {
  filter: blur(1px);
}
/*# sourceMappingURL=limite-historico-pesquisa.component.css.map */
